import React, { Fragment, useEffect, useState, useRef } from "react"
import { Carousel as CarouselReact } from "react-responsive-carousel";
import { useMediaQuery } from "react-responsive";
import SliderImages from "./SliderImages";
import {
	setCurrentIndex,
	show,
	previous,
	next
} from "../../Actions/LightboxImages.action";
import { useDispatch, useSelector } from "react-redux";

const LightboxImages = props => {
	const dispatch = useDispatch();
	const carouselRef = useRef();
	const isAmbiance = props.isAmbiance;
	const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
	const lightBoxImageState = useSelector((state) => state.lightboxImages);
	const [images, setImages] = useState([]);
	const [videoImage, setVideoImage] = useState({});
	const [videoImageIndex, setVideoImageIndex] = useState(0);

	let settings = {
		infiniteLoop: true,
		useKeyboardArrows: true,
		showIndicators: true,
		showStatus: false,
		showThumbs: false,
		transitionTime: 300,
		dynamicHeight: true
	}

	const [activeSlide, setActiveSlide] = useState(lightBoxImageState.index)
	const goToSlide = slideNumber => {
		setActiveSlide(slideNumber)
	}
	const customRenderThumb = children =>
		children.map((_, index) => <img src={props.thumbnails[index].src} alt={props.thumbnails[index].alt} />)

	const closeClickOutside = e => {
		const { classList } = e.target

		if (
			classList.contains("carousel-root") ||
			classList.contains("slideshow-image")
		)
			dispatch(show(false));
	}

	useEffect(() => {
		if (carouselRef && carouselRef.current)
			carouselRef.current.goToSlide(activeSlide)
	});

	useEffect(() => {
		if (props.images) {
			setImages(props.images.filter(x => !x.iframe));
			const videoImageItem = props.images.find(x => x.iframe);
			const videoImageIndex = props.images.findIndex(x => x === videoImageItem);
			setVideoImage(videoImageItem);
			setVideoImageIndex(videoImageIndex);
		}
	}, [props]);

	if (!images || images.length < 1) return null

	return (
		isTabletOrMobile ? <SliderImages {...props}></SliderImages> :
			<>
				<div className="lightbox desktop">
					<div className="lightbox__main-image">
						<figure className="lightbox__image-container">
							<a
								data-src={images[lightBoxImageState.index === videoImageIndex ? 0 : lightBoxImageState.index].src}
								itemProp="url"
								onClick={() => {
									//goToSlide(lightBoxImageState.index);
									//dispatch(setCurrentIndex(lightBoxImageState.index, false, false));
									dispatch(show(true));
								}}
								className={`product-image ${isAmbiance ? "transparent-bg" : ""}`}		
								tabIndex={0}	
								onKeyDown={(e) => {
									if (e.code === 'Enter') {
										dispatch(show(true));
									}
								}}					
							>
								<img
									className="lightbox__image--main"
									itemProp="image"
									src={props.thumbnails[lightBoxImageState.index === videoImageIndex ? 0 : lightBoxImageState.index].src}
									alt={props.thumbnails[lightBoxImageState.index === videoImageIndex ? 0 : lightBoxImageState.index].alt}
								/>

								{images.length > 1 && (
									<svg className="more-images-svg">
										<use href="/ui/images/tibergs-svg/sprite/sprite.svg#more-dots"></use>
									</svg>
								)}
							</a>
						</figure>
					</div>
					{images.length > 1 && (
						<div className="lightbox__thumbnails">
							<div className="lightbox__thumbnails--items">
								{images.map(
									(image, index) =>
										index < 6 && (
											<div
												className="lightbox__image-container image-container"
												key={index}
											>
												<a
													data-src={image.src}
													itemProp="url"
													onClick={() => {
														goToSlide(index);
														dispatch(setCurrentIndex(index, false, false));
														if (index === 5 && images.length > 6) {
															dispatch(show(true));
														}
													}}
													onKeyDown={(e) => {														
														if (e.code === 'Enter') {
															goToSlide(index);
															dispatch(setCurrentIndex(index, false, false));
															if (index === 5 && images.length > 6) {
																dispatch(show(true));
															}
														}
													}}
													className="product-image"
													tabIndex={0}
												>
													{
														<img
															className="lightbox__image--alter"
															itemProp="image"
															src={props.thumbnails[index] && props.thumbnails[index].src}
															alt={props.thumbnails[index] && props.thumbnails[index].alt}
														/>
													}
													{index === 5 && images.length > 6 && (
														<span className="lightbox__image--overlay">
															+{images.length - 6}
														</span>
													)}
												</a>
											</div>
										)
								)}
								{videoImage &&
									<div
										className="lightbox__image-container image-container"
										key={videoImageIndex}
									>
										<a
											data-src={videoImage.src}
											itemProp="url"
											onClick={() => {
												goToSlide(videoImageIndex);
												dispatch(setCurrentIndex(videoImageIndex, false, false));
												dispatch(show(true));
											}}
											className="product-image"
											tabIndex={0}
											onKeyDown={(e) => {														
												if (e.code === 'Enter') {
													goToSlide(videoImageIndex);
													dispatch(setCurrentIndex(videoImageIndex, false, false));
													dispatch(show(true));
												}
											}}
										>
											{
												<img
													className="lightbox__image--alter image-video"
													itemProp="image"
													src={props.thumbnails[videoImageIndex] && props.thumbnails[videoImageIndex].src}
													alt={props.thumbnails[videoImageIndex] && props.thumbnails[videoImageIndex].alt}
												/>
											}
										</a>
									</div>
								}
							</div>
						</div>
					)}
				</div>

				<div
					className={
						"slideshow-overlay" +
						(lightBoxImageState.visible ? " slideshow-overlay--visible" : "")
					}
					onClick={event => {
						closeClickOutside(event)
					}}
				>
					{lightBoxImageState.visible && (
						<div>
							<a
								className="slideshow-close"
								onClick={() => {
									dispatch(show(false));
								}}
							>
								<svg>
									<use href="/ui/images/tibergs-svg/sprite/sprite.svg#close"></use>
								</svg>
							</a>

							<CarouselReact
								{...settings}
								renderThumbs={customRenderThumb}
								selectedItem={activeSlide}
								autoFocus={true}
							>
								{props.images.map((item, index) => {
									return (
										<div
											key={index}
											className={
												"slideshow-item" +
												(item.iframe
													? " slideshow-item--iframe"
													: " slideshow-item--photo slideshow-item--lightbox")
											}
										>
											{item.iframe === "true" ? (
												<iframe
													src={item.src}
													frameBorder="0"
													allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
													allowFullScreen
												></iframe>
											) : (
												<div
													className="slideshow-image"
													dangerouslySetInnerHTML={{ __html: item.src }}
												></div>
											)}
											{item.description && (
												<div className="slideshow-description">
													{item.description}
												</div>
											)}
										</div>
									)
								})}
							</CarouselReact>
						</div>
					)}
				</div>
			</>
	)
}

export default LightboxImages
